module.exports = __webpack_public_path__ + "assets/c51b4e630f8b4c1ee90e0204d54111dc.mp4";